export interface IOutlookConsentDraft {
  tenantId?: string;
  mailbox?: string;
  title?: string;
}

const key = (clientId: string) => `outlook-app-only-draft:${clientId}`;

/**
 * What the form held when the admin left for Microsoft.
 *
 * Every access is guarded: storage throws in a private window and returns
 * nothing after it is cleared, and neither case is worth breaking the form for
 * — the person just retypes the two fields.
 */
export const saveConsentDraft = (
  clientId: string,
  draft: IOutlookConsentDraft,
) => {
  try {
    window.localStorage.setItem(key(clientId), JSON.stringify(draft));
  } catch {
    // not worth a message — the form still works, it just will not be refilled
  }
};

export const readConsentDraft = (
  clientId: string,
): IOutlookConsentDraft | null => {
  try {
    const raw = window.localStorage.getItem(key(clientId));

    return raw ? (JSON.parse(raw) as IOutlookConsentDraft) : null;
  } catch {
    return null;
  }
};

export const clearConsentDraft = (clientId: string) => {
  try {
    window.localStorage.removeItem(key(clientId));
  } catch {
    // see above
  }
};
